import request from '@/utils/request';
import { iCheckIn } from '@/interface/prize';
/**
 * 获取签到营销管理信息
 * @param data
 */
export const getPrizeInfo = (): Promise<any> =>
  request({
    url: '/api/v1/omc/check_in/info',
    method: 'get',
  });

export const postPrizeInfo = (data: iCheckIn): Promise<any> =>
  request({
    data,
    url: '/api/v1/omc/check_in/post',
    method: 'post',
  });
